import { useEffect, useRef } from 'react';
import { accountStore } from '../store/AccountStore';

export const useUserInfo = () => {
  const isInitialized = useRef(false);

  useEffect(() => {
    // 如果已经初始化过，或者已经有用户信息（包括从缓存获取的），就不需要再次请求
    if (!isInitialized.current && !accountStore.userInfo) {
      isInitialized.current = true;
      accountStore.getCurrentUser();
    }
  }, []);

  return accountStore.userInfo;
};
